import { makeAutoObservable } from "mobx"
import { preferredPanePresentation, rememberPanePresentation, type PanePresentation } from "../store/managers/panePresentationPreferences"

export class EmbeddedBrowserSurfaceStore {
    private running = false
    private visible = false
    presentation: PanePresentation = "modal"

    constructor() {
        makeAutoObservable<EmbeddedBrowserSurfaceStore, "running" | "visible">(this)
    }

    startHidden(): void {
        if (this.running) return
        this.presentation = preferredPanePresentation("browser")
        this.running = true
        this.visible = false
    }

    reveal(): void {
        if (!this.running) return
        this.visible = true
    }

    hide(): void {
        this.visible = false
    }

    toggleVisibility(): void {
        if (!this.running) return
        this.visible = !this.visible
    }

    stop(): void {
        this.running = false
        this.visible = false
    }

    dock(): void {
        if (!this.visible) return
        this.presentation = "docked"
        rememberPanePresentation("browser", this.presentation)
    }

    showModal(): void {
        if (!this.visible) return
        this.presentation = "modal"
        rememberPanePresentation("browser", this.presentation)
    }

    get isRunning(): boolean {
        return this.running
    }

    get isVisible(): boolean {
        return this.visible
    }

    get isModalOpen(): boolean {
        return this.visible && this.presentation === "modal"
    }

    get isDocked(): boolean {
        return this.visible && this.presentation === "docked"
    }
}

export const embeddedBrowserSurfaceStore = new EmbeddedBrowserSurfaceStore()
